var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRollingControlWindow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.457 16-3.11-4.686c-.13.016-.325.023-.586.023H3.326V16H.5V0h6.26c1.32 0 2.468.229 3.447.686.978.457 1.728 1.112 2.25 1.965.521.854.782 1.867.782 3.04 0 1.204-.279 2.24-.837 3.109-.558.869-1.359 1.516-2.402 1.943L13.5 16h-3.043zM10.39 5.691c0-1.02-.319-1.805-.956-2.354-.638-.548-1.573-.823-2.805-.823H3.326v6.377H6.63c1.232 0 2.167-.278 2.805-.834.637-.556.956-1.345.956-2.366z",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRollingControlWindow);
export default __webpack_public_path__ + "static/media/rolling-control-window.761b3e80646f2d84bb9eee4496bb7d6e.svg";
export { ForwardRef as ReactComponent };